import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';

/**
 * Full-width call-to-action banner encouraging applicants to submit their form.
 * @param {string} boardYear - e.g. "2026/27"
 */
const CallToAction = ({ boardYear }) => {
  const scrollToPositions = () => {
    document.getElementById('positions-grid')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      aria-label="Apply now call to action"
      className="relative overflow-hidden bg-gradient-to-br from-[#D4AF37] to-[#B8860B] rounded-[3rem] p-8 md:p-16 text-center text-black shadow-2xl shadow-[#D4AF37]/20"
    >
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/20 rounded-full blur-3xl -mr-32 -mt-32" aria-hidden="true" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-black/10 rounded-full blur-3xl -ml-32 -mb-32" aria-hidden="true" />

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        className="relative z-10"
      >
        <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
          Ready to join the
          <br />
          {boardYear} Board?
        </h2>
        <p className="max-w-xl mx-auto text-black/80 text-lg mb-10 font-medium">
          Applications are now open. Find your role and take the next step in your Leo leadership journey.
        </p>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={scrollToPositions}
          className="inline-flex items-center gap-3 px-10 py-5 bg-black text-white rounded-2xl font-extrabold text-xl shadow-xl transition-all hover:bg-black/90"
        >
          View Roles to Apply <FaArrowRight />
        </motion.button>
      </motion.div>
    </section>
  );
};

export default CallToAction;
